export class RoofHookInput {
	public iType: number;
	public iBasePlate: number;
	//base plate variables
	public sVarBasePlateBig: string;
	public sVarBasePlateSmall: string;
	//support shaft variables
	public sVarSuppShaftVarioDuo: string;
	public sVarSuppShaftVarioSolo: string;
	public RoofHookInput() {
	}
	constructor() { }
}